import * as actionTypes from "../actions/registrations/actionTypes";

const confirmRegistration = (
  state = {
    registrationToken: "",
    loading: false,
    registerUserFailure: false,
    registerUserFailureMessage: "",
    registerUserSuccess: false,
    checkRegistrationTokenFailure: false,
    checkRegistrationTokenFailureMessage: "",
    checkRegistrationTokenSuccess: false,
    confirmRegistrationFailure: false,
    confirmRegistrationFailureMessage: "",
    confirmRegistrationSuccess: false
  },
  { type, payload }
) => {
  switch (type) {
    case actionTypes.SET_REGISTRATION_TOKEN:
      return Object.assign({}, state, {
        registrationToken: payload
      });
    case actionTypes.REGISTER_USER_START:
      return Object.assign({}, state, {
        registerUserFailure: false,
        registerUserFailureMessage: "",
        registerUserSuccess: false,
        loading: true
      });
    case actionTypes.REGISTER_USER_SUCCESS:
      return Object.assign({}, state, {
        registerUserFailure: false,
        registerUserFailureMessage: "",
        registerUserSuccess: true,
        loading: false
      });
    case actionTypes.REGISTER_USER_FAILURE:
      return Object.assign({}, state, {
        registrationToken: "",
        registerUserFailure: true,
        registerUserFailureMessage: payload,
        registerUserSuccess: false,
        loading: false
      });
    case actionTypes.REGISTRATION_TOKEN_CHECK_START:
      return Object.assign({}, state, {
        checkRegistrationTokenFailure: false,
        checkRegistrationTokenFailureMessage: "",
        checkRegistrationTokenSuccess: false,
        loading: true
      });
    case actionTypes.REGISTRATION_TOKEN_CHECK_SUCCESS:
      return Object.assign({}, state, {
        registrationToken: payload.registrationToken,
        checkRegistrationTokenFailure: false,
        checkRegistrationTokenFailureMessage: "",
        checkRegistrationTokenSuccess: true,
        loading: false
      });
    case actionTypes.REGISTRATION_TOKEN_CHECK_FAILURE:
      return Object.assign({}, state, {
        registrationToken: "",
        checkRegistrationTokenFailure: true,
        checkRegistrationTokenFailureMessage: payload,
        checkRegistrationTokenSuccess: false,
        loading: false
      });
    case actionTypes.USER_REGISTRATION_CONFIRM_START:
      return Object.assign({}, state, {
        confirmRegistrationFailure: false,
        confirmRegistrationFailureMessage: "",
        confirmRegistrationFailureSuccess: false,
        loading: true
      });
    case actionTypes.USER_REGISTRATION_CONFIRM_SUCCESS:
      return Object.assign({}, state, {
        confirmRegistrationFailure: false,
        confirmRegistrationFailureMessage: "",
        confirmRegistrationSuccess: true,
        loading: false
      });
    case actionTypes.USER_REGISTRATION_CONFIRM_FAILURE:
      return Object.assign({}, state, {
        confirmRegistrationFailure: true,
        confirmRegistrationFailureMessage: payload,
        confirmRegistrationSuccess: false,
        loading: false
      });

    default:
      return state;
  }
};

export default confirmRegistration;
